import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { GameInfoDialog } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { open } = state.gameInfoDialog
  const { language } = state.user
  return ({
    open,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleEnter: () => {
      ownProps.onEnter()
    },
    handleClose: () => {
      dispatch(actions.gameInfoDialog.close())
    },
    handleOK: (gameInfo) => {
      ownProps.onOK(gameInfo)
      dispatch(actions.gameInfoDialog.close())
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameInfoDialog)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/GameInfoDialog.js